import * as ActionTypes from "./types"
import TENANTED_API_REQUEST from "../../middleware/ApiRequestMiddleware"
import { clearUser } from "../professionals/user/actions"

// TODO: WABA: Move these when updating the patient/professional state slices
export function tenantUpdated(): any {
	return async (dispatch: (action: any) => Promise<any> | void) => {
		dispatch(clearUser())
	}
}

export function updateTenantEnvironment(): any {
	return {
		[TENANTED_API_REQUEST]: {
			endpoint: `/api/admin/environment`,
			method: "GET",
			types: [
				ActionTypes.TENANT_ENVIRONMENT_REQUEST,
				ActionTypes.TENANT_ENVIRONMENT_RECEIVE,
				ActionTypes.TENANT_ENVIRONMENT_FAILURE
			]
		}
	}
}
